import { CannedMessage } from './getForCannedMessagesView'
import { adminHttpClient } from '../../commons/adminHttpClient'

const upsertCannedMessage = (data: CannedMessage): Promise<any> => {
  return adminHttpClient.put('DocReview/CannedMessages', data)
}

export default upsertCannedMessage
